import React, { useState, useRef, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Area } from "react-easy-crop/types";
import "./Popups.css";

interface ImageCropperProps {
  imgSrc: string;
  updateImage: (dataUrl: any) => void;
  closeModal: () => void;
  setIsNext:()=>void;
}

const ImageCropper: React.FC<ImageCropperProps> = ({
  imgSrc,
  updateImage,
  closeModal,
  setIsNext,
}) => {
  const [crop, setCrop] = useState<{
    x: number;
    y: number;
    width: number;
    height: number;
  }>({
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [zoom, setZoom] = useState(1);
  const previewCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const [isGrabbing, setIsGrabbing] = useState(false);
  // Update crop state with new x, y values
  const handleCropChange = useCallback((newCrop: { x: number; y: number }) => {
    setCrop((prevCrop) => ({
      ...prevCrop,
      ...newCrop,
    }));
  }, []);

 const getCroppedImg = async (imageSrc: string, pixelCrop: any) => {
    const image = await loadImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return null;

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );
    return canvas.toDataURL("image/jpeg");
  };
  const loadImage = (src: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };
  // Handle crop completion, update the avatar and preview image
  const handleCropComplete = useCallback(
    async (croppedArea: Area, croppedAreaPixels: Area) => {
      if (previewCanvasRef.current) {
        const dataUrl = await getCroppedImg(imgSrc, croppedAreaPixels);
        updateImage(dataUrl);
      }
    },
    [imgSrc, updateImage]
  );

  // Save the cropped image and close the modal
  const handleSave = () => {
    setIsNext();
    closeModal(); 
  };
  // Toggle grab and grabbing cursors
  const handlePointerDown = () => setIsGrabbing(true);
  const handlePointerUp = () => setIsGrabbing(false);
  return (
    <div className="d-flex flex-column">
      <div
        style={{ position: "relative", width: "400px", height: "400px" }}
        onPointerDown={handlePointerDown}
        onPointerUp={handlePointerUp}
      >
        <Cropper
          image={imgSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={handleCropChange}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          cropShape="round" // Sets the crop frame to be circular
          showGrid={false}
          style={{
            containerStyle: {
              maxWidth: "400px",
              maxHeight: "400px",
              overflow: "hidden",
              cursor: isGrabbing ? "grabbing" : "grab",
            },
            mediaStyle: {
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            },
          }}
        />
      </div>
      <canvas
        ref={previewCanvasRef}
        style={{
          display: "none", 
          width: crop.width,
          height: crop.height,
        }}
      />

      <div className="mt-4 d-flex justify-content-center">
        <button className="btn-next-profile-picture" onClick={handleSave}>
          Next
        </button>
      </div>
    </div>
  );
};

export default ImageCropper;
